
import BlokkliComponent_gallery_index from '/builds/bazinga/bs.ch/frontend/components/Paragraph/Gallery/index.vue'

const gallery: Record<string, any> = {
  block_gallery: BlokkliComponent_gallery_index
}
export default gallery